<div class="relative flex w-full items-center justify-center">
	<span>&copy; 2025 RB Somerville</span>

	@if (appVersion) {
		<div class="absolute right-0 text-right text-xs text-gray-500">
			<div>v{{ appVersion }}</div>
			@if (buildHash) {
				<div class="text-[10px] text-gray-400">build: {{ buildHash }}</div>
			}
		</div>
	}
</div>
